import { generateImagePath } from '../../../../helpers/helpers';
import { commonFieldConfig, commonFieldTypes } from '../inputs/field.config';
import FieldTypeSelector from '../inputs/Index';
import TextInputField from '../inputs/TextInputField';

export default function FooterAdvertisementSection({
  handleInputChange,
  investmentData,
}) {
  // English Footer Advertisement Fields
  const footerAdvertisementSectionFieldsEn = [
    {
      label: 'Footer Text',
      value: investmentData.en.footerAdvertisementSection.text,
      section: 'footerAdvertisementSection',
      field: 'text',
      config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
    },
  ];

  const imageSection = {
    label: 'Footer Image URL',
    value: investmentData.en.footerAdvertisementSection.image,
    section: 'footerAdvertisementSection',
    field: 'image',
    config: { ...commonFieldConfig['en'][commonFieldTypes.image] },
  };

  // Arabic Footer Advertisement Fields
  const footerAdvertisementSectionFieldsAr = [
    {
      label: 'نص التذييل',
      value: investmentData.ar.footerAdvertisementSection.text,
      section: 'footerAdvertisementSection',
      field: 'text',
      config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
    },
    // {
    //   label: 'رابط صورة التذييل',
    //   value: investmentData.ar.footerAdvertisementSection.image,
    //   section: 'footerAdvertisementSection',
    //   field: 'image',
    //   isSameValue: true,
    // },
  ];

  return (
    <section className="mb-5">
      <h3 className="mb-3">Footer Advertisement</h3>
      <img
        src={generateImagePath('footer-section.webp')}
        alt=""
        className="mb-3 w-100"
      />

      <div className="row">
        {/* English Footer Advertisement Fields */}
        <div className="col-md-6">
          {footerAdvertisementSectionFieldsEn.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              config={field.config}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'en',
                  isSameValue: field.config.isSameValue,
                })
              }
            />
          ))}
        </div>

        {/* Arabic Footer Advertisement Fields */}
        <div className="col-md-6" dir="rtl">
          {footerAdvertisementSectionFieldsAr.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              config={field.config}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'ar',
                })
              }
            />
          ))}
        </div>
      </div>
      {imageSection && (
        <FieldTypeSelector
          fieldName={imageSection.field}
          label={imageSection.label}
          value={imageSection.value}
          config={imageSection.config}
          onInputChange={(e) =>
            handleInputChange({
              e,
              section: imageSection.section,
              field: imageSection.field,
              lang: 'en',
              isSameValue: imageSection.config.isSameValue,
            })
          }
        />
      )}
    </section>
  );
}
